import { from } from 'rxjs'
import { mergeMap, map, tap, distinct, toArray } from 'rxjs/operators'
import { serviceOverviewService } from '../../service/service-overview-service'

export const namespace = 'SERVICE_OVERVIEW'

export const types = {
  GET_SERVICE_OVERVIEW: 'getServiceOverview',
  SET_SERVICE_OVERVIEW: 'setServiceOverview',
  SET_REGION: 'setRegionCode'
}

const state = {
  productUiId: null,
  title: null,
  content: null,
  imageUrl: null,
  breadcrumbs: null,
  manualUrl: null,
  contents: [],
  service: {
    possibleToEnable: false
  },
  regionCodeList: []
}

const mutations = {
  [types.SET_SERVICE_OVERVIEW](state, payload) {
    state.productUiId = payload.productUiId
    state.title = payload.title
    state.content = payload.content
    state.imageUrl = payload.imageUrl
    state.breadcrumbs = payload.breadcrumbs
    state.manualUrl = payload.manualUrl
    state.contents = payload.contents
    state.service = payload.service
    from(state.contents)
      .pipe(
        mergeMap(content => from(content.subContents)),
        map(subContent => subContent.regionCode),
        distinct(),
        toArray()
      )
      .subscribe(regionCodeList => (state.regionCodeList = regionCodeList))
  },
  [types.SET_REGION](state, region) {
    state.selectedRegion = region
  }
}

const actions = {
  [types.GET_SERVICE_OVERVIEW]({ commit, dispatch }, { lang, parentHomepageUiName, homepageUiName, countryCode }) {
    return serviceOverviewService
      .getServiceOverview$(lang, parentHomepageUiName, homepageUiName, countryCode)
      .pipe(
        tap(serviceOverview => {
          commit(types.SET_SERVICE_OVERVIEW, serviceOverview)
        })
      )
      .toPromise()
  },
  [types.SET_REGION]({ commit }, region) {
    commit(types.SET_REGION, region)
  }
}

export const serviceOverviewStore = {
  state,
  mutations,
  actions,
  namespace,
  types
}
